export default [
  {
    slideData: [
      {
        text: 'I love it! Screenapp is great to record short clips.',
      },
      {
        text:
          'I finally found a screen recorder to record with voice! This is brilliant!',
      },
      {
        text:
          'This app is GREAT!!! It is fantastic that you don’t have to download it.',
      },
    ],
  },
  // {
  //     slideData: [
  //         {}, {}, {}
  //     ],
  // },
];
